import InnerComponent from '@Components/Sales/Consumption/ConsumptionList';
import orgContainer from '@Components/AppContainer';

const ListConsumption = () => ((orgContainer(InnerComponent)));
export default ListConsumption;